<script lang="ts">
	import { resolve } from '$app/paths';
	import { m } from '$lib/paraglide/messages.js';
	import { localizeHref } from '@/paraglide/runtime';
	import type { Snippet } from 'svelte';

	interface Props {
		heroImage: Snippet<[string]>;
		eyebrow: string;
		breadcrumbLabel: string;
		lead: string;
		children: Snippet;
	}

	let { heroImage, eyebrow, breadcrumbLabel, lead, children }: Props = $props();
</script>

<header class="zp-phero">
	<div class="absolute inset-0 z-0" aria-hidden="true">
		{@render heroImage('h-full w-full object-cover')}
	</div>
	<div
		class="relative z-2 mx-auto w-full max-w-[1240px] px-5 pb-14 text-zp-paper md:px-10 md:pb-[70px]"
	>
		<nav aria-label="Breadcrumb" class="mb-4 text-[0.78rem] text-zp-paper/75">
			<ol class="flex flex-wrap items-center gap-1.5">
				<li>
					<a href={resolve(localizeHref('/'))} class="transition-colors hover:text-white">
						{m.seo_breadcrumb_home()}
					</a>
				</li>
				<li aria-hidden="true" class="text-zp-paper/45">/</li>
				<li>
					<span class="text-zp-paper/92" aria-current="page">{breadcrumbLabel}</span>
				</li>
			</ol>
		</nav>
		<span class="text-[0.72rem] font-semibold tracking-[0.22em] text-zp-accent-light uppercase">
			{eyebrow}
		</span>
		<h1 class="mt-5 max-w-[18ch] text-[clamp(2.4rem,5.2vw,4.6rem)] leading-[1.02] text-white">
			{@render children()}
		</h1>
		<p class="mt-5 max-w-[48ch] text-[1.18rem] text-zp-paper/88">{lead}</p>
	</div>
</header>
